import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import {
  InputDocField,
  InputImageField,
  TextareaField,
} from "components/Common/input-fields"
import fileImage from "../../../assets/images/fileimage.png"
import {
  allApplications,
  DeleteMiscellaneousDoc,
} from "redux/slice/applications/applicationSlice"
import { MdDelete } from "react-icons/md"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import Loader from "components/Common/loader"
import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Col,
  Modal,
  Row,
  Table,
} from "reactstrap"
export default function DocumentsInfoForm({
  tabs,
  updateTabComplete,
  handleChangeInfo,
  handleFileChange,
  handleFileRemove,
  documentsInfo,
  forView,
  componentFor,
  role,
}) {
  let infoObject = "documents"
  const dispatch = useDispatch()
  const { miscellaneousDocs, currentApplicationSelected, loading } =
    useSelector(allApplications)
  const [deleteIdState, setDeleteIdState] = useState(null)
  const [deleteModalState, setDeleteModalState] = useState(false)
  useEffect(() => {
    console.log("documentsInfo", documentsInfo)
  }, [documentsInfo])

  console.log("deleteIdState", deleteIdState)
  const handleDeleteMiscDoc = doc_id => {
    console.log("doc_id", doc_id)
    let data = {
      studentId: currentApplicationSelected?.id,
      documentId: doc_id,
    }
    console.log("data to delete misc", data)
    dispatch(DeleteMiscellaneousDoc(data))
      .unwrap()
      .then(() => {
        setDeleteModalState(false)
      })
      .catch(error => {
        console.log("delete misc doc error", error)
      })
  }
  return (
    <React.Fragment>
      <h5
        id="documents-details-section"
        className="mt-4 text-secondary-si section-heading page-break"
      >
        Documents Details
      </h5>

      <InputImageField
        label="NIC Image (Front)"
        compulsory={true}
        disabled={forView}
        value={documentsInfo.nicImage}
        placeholder="Upload NIC Image (Front)"
        handleFileRemove={() => handleFileRemove(infoObject, "nicImage")}
        onChange={e => handleFileChange(infoObject, "nicImage", e)}
      />
      <InputImageField
        label="NIC Image (Back)"
        compulsory={true}
        disabled={forView}
        value={documentsInfo.nicImageBack}
        placeholder="Upload NIC Image (Back)"
        handleFileRemove={() => handleFileRemove(infoObject, "nicImageBack")}
        onChange={e => handleFileChange(infoObject, "nicImageBack", e)}
      />
      <InputImageField
        label="Passport Size Picture"
        compulsory={true}
        disabled={forView}
        value={documentsInfo.passportSizePicture}
        placeholder="Upload Passport Size Picture"
        handleFileRemove={() =>
          handleFileRemove(infoObject, "passportSizePicture")
        }
        onChange={e => handleFileChange(infoObject, "passportSizePicture", e)}
      />
      <InputImageField
        label="Admission Letter"
        compulsory={true}
        disabled={forView}
        value={documentsInfo.addmissionLettter}
        placeholder="Upload Admission Letter"
        handleFileRemove={() =>
          handleFileRemove(infoObject, "addmissionLettter")
        }
        onChange={e => handleFileChange(infoObject, "addmissionLettter", e)}
      />
      <InputImageField
        label="Marksheet"
        compulsory={true}
        disabled={forView}
        value={documentsInfo.marksheet}
        placeholder="Upload Marksheet"
        handleFileRemove={() => handleFileRemove(infoObject, "marksheet")}
        onChange={e => handleFileChange(infoObject, "marksheet", e)}
      />
      <InputImageField
        label="Income Verification"
        compulsory={true}
        disabled={forView}
        value={documentsInfo.incomeVerification}
        placeholder="Upload Income Verification"
        handleFileRemove={() =>
          handleFileRemove(infoObject, "incomeVerification")
        }
        onChange={e => handleFileChange(infoObject, "incomeVerification", e)}
      />
      <InputImageField
        label="Tuition Fee Schedule"
        compulsory={false}
        disabled={forView}
        value={documentsInfo.tutionFeeSchedule}
        placeholder="Upload Tuition Fee Schedule"
        handleFileRemove={() =>
          handleFileRemove(infoObject, "tutionFeeSchedule")
        }
        onChange={e => handleFileChange(infoObject, "tutionFeeSchedule", e)}
      />
      <InputImageField
        label="Fee Receipt"
        compulsory={false}
        disabled={forView}
        value={documentsInfo.feeReceiptsImage}
        placeholder="Upload Fee Receipt"
        handleFileRemove={() =>
          handleFileRemove(infoObject, "feeReceiptsImage")
        }
        onChange={e => handleFileChange(infoObject, "feeReceiptsImage", e)}
      />
      <InputImageField
        label="Miscellaneous Expense"
        compulsory={false}
        disabled={forView}
        value={documentsInfo.miscellaneousExpense}
        placeholder="Upload Miscellaneous Expense"
        handleFileRemove={() =>
          handleFileRemove(infoObject, "miscellaneousExpense")
        }
        onChange={e => handleFileChange(infoObject, "miscellaneousExpense", e)}
      />
      {/* <InputImageField
        label="Other Documents"
        compulsory={false}
        disabled={forView}
        value={documentsInfo.otherDocuments}
        placeholder="Upload Other Document"
        handleFileRemove={() => handleFileRemove(infoObject, "otherDocuments")}
        onChange={e => handleFileChange(infoObject, "otherDocuments", e)}
      /> */}
      {documentsInfo.description && (
        <TextareaField
          label="Miscellaneous Detail"
          placeholder="Enter Miscellaneous Detail"
          className="col-sm-12 col-md-6 col-lg-4 my-2"
          compulsory={true}
          disabled={forView}
          type="text"
          value={documentsInfo.description}
          onChange={e =>
            handleChangeInfo(infoObject, "description", e.target.value)
          }
        />
      )}
      <h5 className="mt-2 text-secondary-si section-heading page-break">
        Additional Documents
      </h5>
      {loading ? (
        <Loader />
      ) : (
        <>
          {miscellaneousDocs && miscellaneousDocs.length > 0 ? (
            miscellaneousDocs?.map((item, index) => (
              <div className="input-fields-group" key={index}>
                <h6 className="mt-3 text-secondary-si">
                  Year {item?.year} Documents
                </h6>
                <div className="row">
                  {item?.documentUrls && item?.documentUrls?.length > 0
                    ? item?.documentUrls?.map((image, index) => (
                        <div className="col xs-6 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center align-items-center flex-column">
                          <InputImageField
                            className="my-2"
                            label={`${image?.documentType ? image?.documentType : "Others"}`}
                            compulsory={false}
                            disabled={forView}
                            value={image?.documentUrl}
                            placeholder="Upload Miscellaneous Expense"
                            handleFileRemove={() =>
                              handleFileRemove(
                                infoObject,
                                "miscellaneousExpense",
                              )
                            }
                            onChange={e =>
                              handleFileChange(
                                infoObject,
                                "miscellaneousExpense",
                                e,
                              )
                            }
                          />
                          {role === "Admin" && componentFor === "View" && (
                            <button
                              className="btn btn-danger btn-sm my-1"
                              style={{ width: "120px" }}
                              onClick={e => {
                                e.stopPropagation()
                                setDeleteIdState(image?.id)
                                setDeleteModalState(true)
                                // handleDeleteMiscDoc(image?.id)
                              }}
                            >
                              <MdDelete />
                            </button>
                          )}
                        </div>
                        // <div
                        //   className="col-6 col-md-3 col-lg-2 d-flex justify-content-center mb-3"
                        //   key={index}
                        //   onClick={() =>
                        //     window.open(image?.documentUrl, "_blank")
                        //   }
                        // >
                        //   <div
                        //     className="text-center position-relative"
                        //     style={{ cursor: "pointer" }}
                        //   >
                        //     {/* <a onClick={() => window.open(image, "_blank")}> */}
                        //     <img
                        //       src={fileImage}
                        //       alt={`Year ${item?.year} Document`}
                        //       className="img-thumbnail"
                        //       style={{
                        //         maxWidth: "100px",
                        //         maxHeight: "100px",
                        //         objectFit: "contain",
                        //       }}
                        //     />
                        //     <p
                        //       className="text-truncate text-wrap"
                        //       style={{
                        //         maxWidth: "100px",
                        //         marginBottom: "30px",
                        //       }}
                        //     >
                        //       {image?.documentType
                        //         ? image?.documentType
                        //         : "Other"}
                        //     </p>
                        //     {/* </a> */}
                        //     <button
                        //       className="btn btn-danger btn-sm w-100 position-absolute start-0 bottom-0 mt-5"
                        //       onClick={e => {
                        //         e.stopPropagation()
                        //         handleDeleteMiscDoc(image?.id)
                        //       }}
                        //     >
                        //       <MdDelete />
                        //     </button>
                        //   </div>
                        // </div>
                      ))
                    : null}
                </div>
              </div>
            ))
          ) : (
            <div>
              <h6 className="text-secondary-si">
                No Additional Documents Found
              </h6>
            </div>
          )}
        </>
      )}
      <Modal isOpen={deleteModalState} centered>
        <Card className="bg-white">
          <CardBody className="mt-2">
            <h5 style={{ fontWeight: "normal" }}>
              Are You Sure. You want to Delete ?
            </h5>
          </CardBody>
          <CardFooter>
            <div className="mt-4 float-end">
              <button
                className="btn btn-danger me-2"
                onClick={() => handleDeleteMiscDoc(deleteIdState)}
              >
                Yes
              </button>
              <button
                className="btn btn-primary"
                onClick={() => setDeleteModalState(false)}
              >
                No
              </button>
            </div>
          </CardFooter>
        </Card>
      </Modal>
    </React.Fragment>
  )
}
